import { queryClient } from "@/api/core";

import { BoostQueryKeys } from "./query-keys";

import type { Boost } from "@/schemas";
import type { PaginatedResult } from "@/utils/queries";
import type { InfiniteData } from "@tanstack/react-query";

function updateBoostInList(uuid: string, patch: Partial<Boost>): void {
  queryClient.setQueryData<InfiniteData<PaginatedResult<Boost>>>(
    BoostQueryKeys.list(),
    (data) => {
      if (!data) return data;
      let anyChanged = false;
      const pages = data.pages.map((page) => {
        let changed = false;
        const result = page.result.map((row) => {
          if (row.uuid === uuid) {
            changed = true;
            return { ...row, ...patch };
          }
          return row;
        });
        if (changed) anyChanged = true;
        return changed ? { ...page, result } : page;
      });
      return anyChanged ? { ...data, pages } : data;
    },
  );
}

export { updateBoostInList };
